import styled from 'styled-components';

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 52px 0 40px 0;

  @media screen and (max-width: 960px) {
    padding: 24px 20px 32px 20px;
    border-radius: 0;
  }
`;

export const Container = styled.div`
  width: 624px;

  @media screen and (max-width: 960px) {
    width: 100%;
  }
`;

export const Line = styled.div`
  display: flex;
  justify-content: space-between;
  margin-bottom: 40px;

  @media screen and (max-width: 960px) {
    margin-bottom: 0px;
  }
`;

export const Back = styled.div`
  display: none;

  @media screen and (max-width: 960px) {
    display: block;
  }
`;

export const Title = styled.h2`
  font-weight: 700;
  font-size: 36px;
  color: ${(props) => props.theme.colors.primaryDark2};
  display: block;

  @media screen and (max-width: 960px) {
    display: none;
  }
`;

export const BreadCrumb = styled.div`
  display: block;
  margin-top: 10px;
  font-size: 16px;
  font-weight: 400;
  color: ${(props) => props.theme.colors.primaryDark2};

  @media screen and (max-width: 960px) {
    display: none;
  }

  #bar {
    color: ${(props) => props.theme.colors.secundary};
  }

  #link {
    color: ${(props) => props.theme.colors.secundary};

    &:hover {
      cursor: pointer;
      text-decoration: underline;
    }
  }
`;

export const InfoContainer = styled.div`
  display: flex;
  flex-direction: column;

  h2 {
    font-weight: 700;
    font-size: 24px;
    color: ${(props) => props.theme.colors.primaryDark2};
    margin-bottom: 8px;
  }

  p {
    font-weight: 700;
    font-size: 16px;
    color: ${(props) => props.theme.colors.gray};
    margin-bottom: 8px;
  }

  .space-right {
    margin-right: 4px;
  }

  .options {
    display: flex;
    color: ${(props) => props.theme.colors.gray};
    font-weight: 400;
    font-size: 14px;
    margin-bottom: 4px;
    line-height: 130%;
  }

  a {
    text-decoration: underline;
    color: ${(props) => props.theme.colors.primary};
    margin-left: 4px;
    cursor: pointer;
  }

  .date {
    font-weight: 700;
    margin-left: 4px;
  }

  @media screen and (max-width: 960px) {
    h2 {
      font-size: 20px;
    }
  }
`;

export const PaymentContainer = styled.div`
  margin-top: 28px;

  h2 {
    font-weight: 700;
    font-size: 16px;
    text-transform: uppercase;
    color: ${(props) => props.theme.colors.primaryDark2};
    margin-bottom: 20px;
  }

  .container {
    width: 100%;
    height: 113px;
    background: ${(props) => props.theme.colors.white};
    box-shadow: -4px -4px 8px rgba(255, 255, 255, 0.8),
      4px 4px 6px rgba(36, 36, 36, 0.1);
    border-radius: ${(props) =>
      Number(props.theme.radiusCards)
        ? `${props.theme.radiusCards}px`
        : '60px'};

    display: flex;
    padding: 20px 52px;
  }

  .quantity {
    width: 56px;
    height: 56px;
    background: ${(props) => props.theme.colors.primary};
    color: ${(props) => props.theme.colors.white};
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: ${(props) =>
      Number(props.theme.borderRadius)
        ? `${props.theme.borderRadius}px`
        : '5px'};
    font-weight: 700;
    font-size: 21px;
  }

  .info {
    display: flex;
    flex-direction: column;
    margin-left: 20px;
  }

  p {
    font-weight: 400;
    font-size: 14px;
    color: ${(props) => props.theme.colors.gray};
    margin-bottom: 4px;
  }

  .strong {
    margin-top: 1px;
    font-weight: 700;
  }

  h3 {
    font-weight: 700;
    font-size: 24px;
    color: ${(props) => props.theme.colors.primaryDark2};
  }

  @media screen and (max-width: 960px) {
    .container {
      border-radius: ${(props) =>
        Number(props.theme.radiusCards)
          ? `${props.theme.radiusCards}px`
          : '10px'};
      padding: 24px 20px;
    }
  }
`;

export const ButtonContainer = styled.div`
  display: flex;
  justify-content: space-between;
  margin-top: 28px;

  .desktop {
    display: block;
  }

  .mobile {
    display: none;
  }

  @media screen and (max-width: 960px) {
    .desktop {
      display: none;
    }

    .mobile {
      display: block;
    }
  }
`;

export const Button = styled.button<{ color: string }>`
  height: 60px;
  color: ${(props) =>
    props.color === 'primary'
      ? props.theme.colors.white
      : props.theme.colors.primary};
  background: ${(props) =>
    props.color === 'primary'
      ? props.theme.colors.primary
      : props.theme.colors.white};
  text-transform: uppercase;
  padding: 19px 24px;
  box-shadow: 0px 4px 4px rgba(36, 36, 36, 0.2);
  border-radius: ${(props) =>
    Number(props.theme.borderRadius)
      ? `${props.theme.borderRadius}px`
      : '16px'};
  font-size: 16px;
  font-weight: bold;

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
`;
